/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} General_Delete_Confirm_ErrorInputs */

const en_general_delete_confirm_error = /** @type {(inputs: General_Delete_Confirm_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The entered name does not match. Please try again.`)
};

const de_general_delete_confirm_error = /** @type {(inputs: General_Delete_Confirm_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der eingegebene Name stimmt nicht überein. Bitte versuchen Sie es erneut.`)
};

/**
* | output |
* | --- |
* | "The entered name does not match. Please try again." |
*
* @param {General_Delete_Confirm_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const general_delete_confirm_error = /** @type {((inputs?: General_Delete_Confirm_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<General_Delete_Confirm_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_general_delete_confirm_error(inputs)
	return de_general_delete_confirm_error(inputs)
});